import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const PROGRAMS = [
  {
    id: 'elemental',
    title: 'Programa Educativo Elemental',
    description: 'Apoyo académico personalizado para estudiantes de escuela elemental, fortaleciendo bases sólidas en todas las materias.',
    image: 'https://customer-assets.emergentagent.com/job_formando-lideres/artifacts/2ootpy36_d1505ed5-d984-4a60-a3cb-6ba80b60fc45.JPG',
    alt: 'Grupo de estudiantes elemental trabajando en proyecto colaborativo'
  },
  {
    id: 'intermedia',
    title: 'Programa Educativo Intermedia',
    description: 'Refuerzo académico enfocado en desarrollar pensamiento crítico y habilidades avanzadas para el nivel intermedio.',
    image: 'https://customer-assets.emergentagent.com/job_formando-lideres/artifacts/7vm405h7_1a22a3af-b9ab-475a-9193-e27a6405e384.JPG',
    alt: 'Estudiantes pintando un mural creativo'
  },
  {
    id: 'superior',
    title: 'Programa Educativo Superior',
    description: 'Preparación académica completa para estudiantes de escuela superior, con énfasis en éxito universitario.',
    image: 'https://customer-assets.emergentagent.com/job_formando-lideres/artifacts/hk3dhf3o_87724a32-3c72-47d4-8672-c8a0ac1c08c6.JPG',
    alt: 'Estudiantes de escuela superior en proyecto cultural'
  }
];

export const HomeProgramsPreview = () => (
  <section className="py-20 md:py-28" data-testid="programs-preview-section">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12">
      <div className="text-center mb-16">
        <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#d3b163] mb-4 block">Nuestros Programas</span>
        <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-stone-900 mb-4">
          Servicios diseñados para cada necesidad
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {PROGRAMS.map((program) => (
          <div
            key={program.id}
            className="bg-white rounded-2xl overflow-hidden card-hover shadow-[0_8px_30px_rgb(0,0,0,0.04)]"
            data-testid={`program-card-${program.id}`}
          >
            <div className="h-56 overflow-hidden">
              <img
                src={program.image}
                alt={program.alt}
                className="w-full h-full object-cover object-center"
                loading="lazy"
              />
            </div>
            <div className="p-8">
              <h3 className="text-xl font-medium text-stone-900 mb-3">{program.title}</h3>
              <p className="text-base text-stone-700 leading-relaxed">{program.description}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="text-center mt-12">
        <Link
          to="/ofrecimientos"
          data-testid="view-all-programs-button"
          className="inline-flex items-center gap-2 bg-[#43b6b8] text-white px-8 py-4 rounded-full font-semibold hover:bg-[#359a9c] transition-all active:scale-95"
        >
          Ver todos los ofrecimientos <ArrowRight className="w-5 h-5" />
        </Link>
      </div>
    </div>
  </section>
);
